import { type PriceData } from "../../../../../models/PriceData";
import { nonVolatileText, text } from "../../../../../utils/PriceUtils";
import { IconType } from "../../../../../common/components/icon/IconType";
import { resolveUrl } from "../../../../../utils/url/urlResolver";
import { BottomNavigationItem } from "~/common/components/BottomNavigation/BottomNavigation";
import { CART_PAGE } from "~/utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectMinicartData } from "~/feature/cart/cart/components/Minicart/minicartRedux";
import { userIsCustomer } from "~/utils/roles";
import { PersonalNavItem } from "~/Header/components/headerMenu/PersonalNavItem";

function useMinicartLogic() {
  const { count, total, show, url } = useSelector(selectMinicartData);
  const webservicesDisabled = window.SCHA.config.disableAllWS;
  const totalStr = webservicesDisabled ? "-" : getPriceLabel(total, count);

  return {
    totalStr,
    url: resolveUrl(url),
    isActive: window.location.pathname.endsWith(CART_PAGE),
    show,
    count,
  };
}

export const HeaderMinicart = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  const { show, totalStr, url, count } = useMinicartLogic();

  if (!show) {
    return null;
  }

  let extraProps;
  if (userIsCustomer()) {
    extraProps = {
      label: totalStr,
    };
  } else {
    extraProps = {
      badgeContent: count,
    };
  }

  return (
    <a href={url} className={className} data-test-id={"minicart"}>
      <PersonalNavItem {...extraProps} icon={IconType.Cart} name={t("header.link.cart")} />
    </a>
  );
};
export const MobileMinicart = () => {
  const { show, totalStr, count, url, isActive } = useMinicartLogic();
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  let extraProps;
  if (userIsCustomer()) {
    extraProps = {
      name: totalStr,
    };
  } else {
    extraProps = {
      name: t("breadcrumb.cart"),
      quantity: count,
    };
  }

  return (
    <a href={url} data-test-id={"minicart"}>
      <BottomNavigationItem {...extraProps} icon={IconType.Cart} isActive={isActive} />
    </a>
  );
};

const getPriceLabel = (total: PriceData | undefined, qty: number) => {
  let totalStr;
  if (total === undefined) {
    totalStr = "-";
  } else {
    totalStr = qty > 0 ? text(total, "-") : nonVolatileText(total);
  }
  return totalStr;
};
